module.exports = __webpack_public_path__ + "static/media/logo.8d37b163.png";